import {
  useIdToken,
  useSignInWithEmailAndPassword,
} from 'react-firebase-hooks/auth';
import { Trans, useTranslation } from 'react-i18next';
import { z } from 'zod';

import { auth, auth as firebaseAuth } from '@/app/providers/firebase';
import { useUpdateUserMutation } from '@/features/chat/services/user-update';
import { Button, Form, Input, toast } from '@/uikit/components';

import styles from './EmailConfirmation.module.scss';

const schema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "Email can't be empty.")
    .email('Invalid email format'),
});

interface EmailConfirmationProps {
  onSubmit: () => void;
}
export const EmailConfirmation = ({
  onSubmit,
}: EmailConfirmationProps): React.ReactNode => {
  const [user] = useIdToken(firebaseAuth);
  const [updateUser, { isLoading }] = useUpdateUserMutation();
  const [signInWithEmailAndPassword] = useSignInWithEmailAndPassword(auth);

  const { t } = useTranslation();

  const handleSubmit = async (event: { email: string }): Promise<void> => {
    if (user !== null && user !== undefined) {
      try {
        const res = await updateUser({
          email: event.email,
          userId: user.uid,
        }).unwrap();

        await signInWithEmailAndPassword(event.email, res.data.password);

        onSubmit();
      } catch (error) {
        toast.error('Something went wrong. Please try again.');
      }
    }
  };

  return (
    <div className={styles.container}>
      <Form
        schema={schema}
        id="emailConfirmation"
        onSubmit={handleSubmit}
        defaultValues={{ email: user?.email ?? '' }}
      >
        <div className={styles.container__form}>
          <Form.Item name="email">
            <Input type="text" label={t('emailAddress')} name="email" />
          </Form.Item>
          <Button size="xl" type="submit" loading={isLoading}>
            <Trans i18nKey="userUpdate.saveAndContinue">Save & Continue</Trans>
          </Button>
        </div>
      </Form>
    </div>
  );
};
